export default __webpack_public_path__ + "static/media/avatar-trip.869ba07d.png";